import React from 'react'
import './terms-section.scss'
import { callModal } from '../modal-viewer/modal-store'

const TermsSection = () => {
  const openTermsModal = () => {
    callModal('terms', {
      className: 'modal-terms',
    })
  }
  return (
    <section className="f-terms-section">
      <b>
        <button
          className="f-terms-section__button-link"
          onClick={evt => {
            openTermsModal()
          }}
        >
          Términos y condiciones del juego
        </button>
      </b>
    </section>
  )
}

export default TermsSection
